<template>
  <div class="home">
    <!--    <Swiper class="swiper_c"/>-->
    <!--    <homeAbout/>-->
    <!--    <homeProduct/>-->
    <!--    &lt;!&ndash; <homeSolve/> &ndash;&gt;-->
    <!--    <homePartner/>-->

    <!-- Hero 区域 -->
    <div class="hero">
      <div class="hero-text-container">
        <h1 class="text-5xl font-bold mb-6 text-gray-900">全域品效流量专家</h1>
        <p class="text-2xl text-gray-700 mb-10">懂流量，更懂增长</p>
        <div class="flex space-x-4">
          <el-button  @click="ljzx" style="background-color: #FF6700;height: 42px;width: 162px"
                     type="primary" size="large">
            立即咨询
          </el-button>
          <el-button @click="zxzx" style="background-color: #F20303;height: 42px;width: 162px"
                     type="primary" size="large">
            在线咨询
          </el-button>
        </div>
      </div>
    </div>

    <!-- 核心价值 -->
    <div class="hxjz">
      <div class="hxjz-container">
        <div class="item hxjz-head">
          <h2 class="">核心价值</h2>
          <p class="">我们专注于为品牌提供全链路增长解决方案</p>
        </div>
        <div class="item hxjz-content">
          <div class="con">
            <div class="">
              <img src="../../assets/images/home/bpoi.png">
            </div>
            <h2 class="">保投产</h2>
            <p class="">私域 & CID & UD 多渠道联动，确保每一分投入都带来回报</p>
          </div>
          <div class="con">
            <div class="">
              <img src="../../assets/images/home/bwl.png">
            </div>
            <h2 class="">流量全域赋能</h2>
            <p class="">内容 & 聚光 双引擎驱动，利用爆款内容，赋能流量流转</p>
          </div>
          <div class="con">
            <div class="">
              <img src="../../assets/images/home/qlldyy.png">
            </div>
            <h2 class="">数据模型构建</h2>
            <p class="">定制数据模型，让增长可视化</p>
          </div>
        </div>
        <div class="item hxjz-foot">
          <div class="foot-btns">
            <el-button @click="ljzx" class="!rounded-button whitespace-nowrap" style="background: #F20303;"
                       type="primary"
                       size="large">立即咨询，获取品效方案
            </el-button>
            <el-button @click="zxzx" class="!rounded-button whitespace-nowrap" style="background: #FF6700;border-color: #FF6700;"
                       type="primary"
                       size="large">在线咨询
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心数据 -->
    <div class="hxsj">
      <div class="hxsj-container">
        <div class="item hxsj-head">
          <h2 class="">核心数据</h2>
          <p class="">2018-2022 深耕平台生态五年，以丙方之姿，练就乙方之能，成就甲方之事</p>
          <p class="">2023-2026 用可视化的数据，做成最硬的通货，成为多个头部品牌品效达成的更优解</p>
        </div>
        <div class="item hxsj-content">
          <div class="con">
            <h2 class="">2000+</h2>
            <p class="">合作品牌</p>
          </div>
          <div class="con">
            <h2 class="">90%+</h2>
            <p class="">年度复投率</p>
          </div>
          <div class="con">
            <h2 class="">8亿+</h2>
            <p class="">累计业务规模</p>
          </div>

        </div>
        <div class="item hxsj-content">
          <div class="con">
            <h2 class="">50万+</h2>
            <p class="">达人账号（小红书、抖音、视频号、逛逛）</p>
          </div>
          <div class="con">
            <h2 class="">3000万+</h2>
            <p class="">达人高粘性微信粉丝</p>
          </div>
          <div class="con">
            <h2 class="">200万+</h2>
            <p class="">自有私域宝妈（越璋独占）</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 解决方案 -->
    <div class="jjfa">
      <div class="jjfa-container">
        <div class="item jjfa-head">
          <h2 class="">解决方案</h2>
          <p class="">针对不同平台和场景，提供定制化增长策略</p>
          <p class="">要量，我们有绝对掌控力；要结果，我们给你最简单直接的答案</p>
        </div>
        <div class="item jjfa-content">
          <div class="con">
            <div class="title">
              小红书全域运营
            </div>
            <div class="detail">
              <div class="text">
                <i class="el-icon-success"></i>
                <div class="text-content">
                <span>蒲公英 KOL 报备投放（内容方向策划、优质 KOL 匹配、数据效果优化）</span>
                </div>
              </div>
              <div class="text">
                <i class="el-icon-success"></i>
                <div class="text-content">
                <span>聚光 / UDS / CID 投放（顶级顾问定架构、资深投手控过程、RPA降损耗）</span>
                </div>
              </div>
              <div class="text">
                <i class="el-icon-success"></i>
                <div class="text-content">
                <span>小红书专业号代运营（定制增长策略、日更精细运营）</span>
                </div>
              </div>
              <div class="text">
                <i class="el-icon-success"></i>
                <div class="text-content">
                <span>小红书素人软植入保 ROI（低成本高转化、以战养兵育达人、构建品牌达人生态）</span>
                </div>
              </div>
              <div class="text">
                <i class="el-icon-success"></i>
                <div class="text-content">
                <span>小红书优质素人精选（低成本高曝光，助力品牌预算效率最大化）</span>
                </div>
              </div>

            </div>
          </div>
          <div class="con" >
            <div class="title">
              达人私域保 ROI/CPA
            </div>
            <div class="detail">
              <div class="text">
                <i class="el-icon-success"></i>
                <div class="text-content">
                  <span>保 ROI（全平台、全品类对赌保ROI，以效果唯一准则）</span><br/>
                  <span>撬动公域的增长法器，冷启动的破局利器，抢占市场的决胜杀器</span>
                </div>
              </div>
              <br/><br/>
              <div class="text">
                <i class="el-icon-success"></i>
                <div class="text-content">
                  <span>保 CPA（含 CPC、PV、UV、搜索、注册、关注、新客......）</span>
                  <span>精准达成目标，规模化饱和攻击，人头生意生态里的第一梯队</span>
                </div>
              </div>
              <div class="text"></div>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心优势 -->
    <div class="hxys">
      <div class="hxys-container">
        <div class="item hxys-head">
          <h2 class="">核心优势</h2>
          <p class="">技术、资源、模式三位一体，构建增长护城河</p>
        </div>
        <div class="item hxys-content">
          <div class="con">
            <div class="">
              <img src="../../assets/images/home/jsqd.png">
            </div>
            <h2 class="">技术驱动</h2>
            <p class="">懂平台规则与流量算法，懂用户心智与内容创作，
              以RPA+AI技术建立数据壁垒</p>
          </div>
          <div class="con">
            <div class="">
              <img src="../../assets/images/home/zybl.png">
            </div>
            <h2 class="">资源壁垒</h2>
            <p class="">50万+达人、3000万达人微信私域粉丝、200万宝妈，
              构建独特竞争优势</p>
          </div>
          <div class="con">
            <div class="">
              <img src="../../assets/images/home/xgdb.png">
            </div>
            <h2 class="">对赌破局</h2>
            <p class="">是服务商也是合伙人，对赌ROI或其他KPI
              效果不达标，服务不收费</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 精选客户案例 -->
    <div class="khal">
      <div class="khal-container">
        <div class="item khal-head">
          <h2 class="">精选客户案例</h2>
          <p class="">累计品牌合作2000+ | 累计业务规模8亿+ | 累计实现营销增量9亿+</p>
        </div>
        <div class="item khal-content">
          <div class="jxal-box">
            <div class="small-rect">母婴用品</div>
            <div class="pic-box">
              <img class="pic" src="../../assets/images/khal/MYYP1.png">
              <!--<div class="img-box">
                <img class="pic" src="../../assets/images/khal/1.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/2.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/3.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/4.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/5.png" >
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/6.png" >
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/7.png" >
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/8.png" >
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/9.png" >
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/10.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/11.png" >
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/12.png" >
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/13.png" style="width: 50px">
              </div>-->
            </div>
          </div>
          <div class="jxal-box">
            <div class="small-rect">美妆个护</div>
            <div class="pic-box">
              <img class="pic" src="../../assets/images/khal/MZGH2.png">
              <!--<div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH1.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH2.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH3.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH4.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH5.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH6.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH7.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH8.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH9.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH10.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH11.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/MZGH12.jpeg">
              </div>-->
            </div>
          </div>
          <div class="jxal-box">
            <div class="small-rect">家电家居</div>
            <div class="pic-box">
              <img class="pic" src="../../assets/images/khal/JDJU3.png">
              <!--<div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU1.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU2.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU3.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU4.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU5.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU6.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU7.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU8.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU9.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU10.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/JDJU11.png">
              </div>-->

            </div>
          </div>
          <div class="jxal-box">
            <div class="small-rect">食品酒饮</div>
            <div class="pic-box">
              <img class="pic" src="../../assets/images/khal/SPJY4.png">
              <!--<div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY1.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY2.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY3.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY4.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY5.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY6.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY7.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY8.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY9.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY10.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY11.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SPJY12.png">
              </div>-->
            </div>
          </div>
          <div class="jxal-box">
            <div class="small-rect">时尚生活</div>
            <div class="pic-box">
              <img class="pic" src="../../assets/images/khal/SSSH5.png">
              <!--<div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH1.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH2.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH3.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH4.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH5.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH6.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH7.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH8.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH9.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH10.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH11.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH12.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/SSSH13.png">
              </div>-->

            </div>
          </div>
          <div class="jxal-box">
            <div class="small-rect">保健养生</div>
            <div class="pic-box">
              <img class="pic" src="../../assets/images/khal/BJYS6.png">
              <!--<div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS1.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS2.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS3.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS4.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS5.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS6.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS7.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS8.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS9.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS10.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/BJYS11.svg">
              </div>-->
            </div>
          </div>
          <div class="jxal-box">
            <div class="small-rect">中西药品</div>
            <div class="pic-box">
              <img class="pic" src="../../assets/images/khal/ZXYP7.png">
              <!--<div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP1.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP2.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP3.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP4.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP5.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP6.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP7.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP8.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP9.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/ZXYP10.png">
              </div>-->
            </div>
          </div>
          <div class="jxal-box">
            <div class="small-rect">宠物健康</div>
            <div class="pic-box">
              <img class="pic" src="../../assets/images/khal/CWJK8.png">
              <!--<div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK1.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK2.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK3.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK4.png">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK5.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK6.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK7.gif">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK8.jpeg">
              </div>
              <div class="img-box">
                <img class="pic" src="../../assets/images/khal/CWJK9.jpeg">
              </div>-->
            </div>
          </div>
          <!--<div class="con"></div>-->
        </div>
      </div>
    </div>

    <!-- 精选客户案例 -->
    <div class="lxwm">
      <div class="lxwm-container">
        <div class="item lxwm-head">
          <h2 class="">联系我们</h2>
          <p class="">获取专属品效增长方案，开启您的业务增长之旅</p>
        </div>
        <div class="item lxwm-content">
          <div class="con">
            <el-button @click="ljzx" style="background-color: #F20303;height: 42px" type="primary" size="medium">
              立即咨询
            </el-button>
            <el-button @click="zxzx" style="background-color: #FF6700;border-color: #FF6700;height: 42px" type="primary" size="medium">
              在线咨询
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <LjzxDialog :visible.sync="ljzxOpen" @closeDialog="closeDialog"></LjzxDialog>

    <OnlineDialog :visible.sync="zxzxOpen" @closeDialog="closeZxzxDialog"></OnlineDialog>

  </div>
</template>

<script>
import Swiper from '@/components/Swiper';

import homeAbout from './homeAbout';
import homeProduct from './homeProduct';
import homeSolve from './homeSolve';
import homePartner from './homePartner';
import LjzxDialog from "@/components/Dialog/ljzxDialog.vue";
import OnlineDialog from "@/components/Dialog/onlineDialog.vue";

export default {
  components: {
    LjzxDialog,
    OnlineDialog,
    Swiper,
    homeAbout,
    homeProduct,
    homeSolve,
    homePartner
  },
  data() {
    return {
      ljzxOpen: false,
      zxzxOpen: false,
    }
  },
  created() {
  },
  methods: {
    ljzx() {
      this.ljzxOpen = true;
    },
    closeDialog() {
      this.ljzxOpen = false;
    },
    zxzx() {
      this.zxzxOpen = true;
    },
    closeZxzxDialog() {
      this.zxzxOpen = false;
    },
  }
}
</script>

<style scoped lang='scss'>
.home {
  /*background-color: #ffffff;*/
  font-size: 15px;
  background-color: #F9F2F2;
  .hero {
    margin: 0 auto;
    margin-top: 100px;
    width: 100%;

    height: 500px;
    background-color: #ffffff;
    background-image: url(../../assets/images/首页大图.png);
    background-size: cover; /* 图片充满容器，可能裁剪部分内容 */
    /* 或使用 background-size: contain; 图片完整显示，可能留空白 */
    background-repeat: no-repeat; /* 禁止图片重复 */
    background-position: center; /* 图片居中显示（可选） */

    .hero-text-container {
      width: 41%;
      height: 100%;
      float: right;
      padding-top: 100px;

      h1 {
        font-size: xxx-large;
        color: #ffffff;
      }

      p {
        font-size: x-large;
        color: #ffffff;
        margin-left: 86px;
        margin-top: 31px;
      }

      .space-x-4 {
        button {
          color: #FFF;
          background-color: #FF6700;
          border-color: #FF6700;
          margin-top: 135px;
          border-radius: 10px;
        }

        button:first-of-type {
          margin-left: 300px;
        }

        button:last-of-type {
          margin-left: 12px;
        }
      }
    }
  }

  .hxjz {
    width: 100%;

    height: 592px;
    background-color: #F9F2F2;
    .hxjz-container {
      width: 80%;
      margin: 0 auto;
      padding-top: 50px;

      .item {
        margin-bottom: 30px;

        p {
          color: #858b95;
        }
      }

      .hxjz-head, .hxjz-foot {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      .hxjz-foot {
        button{
          background-color: #FF6700;
          border-color: #FF6700;
          border-radius: 10px;
        }
      }

      .foot-btns {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;

        .el-button + .el-button {
          margin-left: 0;
        }
      }

      .hxjz-head {
        h2 {
          font-size: xx-large;
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
        }
      }

      .hxjz-content {
        display: flex;
        justify-content: center; /* 垂直方向居中（子元素整体在父容器中间） */
        align-items: center; /* 水平方向居中（每个子元素单独居中） */
        gap: 80px;

        .con {
          flex: 1;
          height: 300px;
          background-color: #ffffff;
          border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
          border-radius: 15px;
          box-shadow: 0 0 10px #ebecec; /* 核心属性 */
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 20px;

          h2 {
            font-size: x-large;
            font-weight: bold;
          }

          p {
            margin: 0 20px;
            font-size: 15px;
            /*text-align: center;*/
          }

          img {
            /*text-align: center;*/
            width: 50px;
          }
        }
      }
    }

  }

  .hxsj {
    width: 100%;
    background-color: #FFF;
    .hxsj-container {
      width: 80%;
      margin: 0 auto;
      padding-top: 50px;
      .item {
        margin-bottom: 30px;

        p {
          color: #858b95;
        }
      }

      .hxsj-head {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;

        h2 {
          font-size: xx-large;
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
        }
      }

      .hxsj-content {
        display: flex;
        justify-content: center; /* 垂直方向居中（子元素整体在父容器中间） */
        align-items: center; /* 水平方向居中（每个子元素单独居中） */
        gap: 50px;
        .con {
          flex: 1;
          height: 180px;
          background-color: #F9FAFB;
          border: 1px solid #f9fafb; /* 可选：添加实体边框，与虚影搭配 */
          border-radius: 15px;
          box-shadow: 0 0 10px #f9fafb; /* 核心属性 */
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin-bottom: 30px;
          h2 {
            font-size: 48px;
            margin-bottom:-20px;
            color: #F20303;
          }
          p {
            margin: 0 20px;
            font-size: 15px;
            text-align: center;
            color: #F20303;
          }
        }

      }
    }

  }

  .jjfa {
    width: 100%;
    height: 600px;
    background-color: #F9F2F2;

    .jjfa-container {
      width: 80%;
      margin: 0 auto;
      padding-top: 30px;
      background-color: #F9F2F2;
      .item {
        margin-bottom: 30px;

        p {
          color: #858b95;
          font-size: 16px;
        }
      }

      .jjfa-head {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;

        h2 {
          font-size: xx-large;
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
        }
      }

      .jjfa-content {
        display: flex;
        justify-content: center; /* 垂直方向居中（子元素整体在父容器中间） */
        align-items: center; /* 水平方向居中（每个子元素单独居中） */
        gap: 50px;
        padding: 0 50px 60px 60px;
        .con {
          flex: 1;
          min-height: 350px;
          height: auto;
          background-color: #ffffff;
          border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
          border-radius: 15px;
          box-shadow: 0 0 10px #ebecec; /* 核心属性 */
          padding: 10px 20px;
          margin-bottom: 30px;
          .title {
            font-size: 23px;
            font-weight: bold;
          }

          .detail {
            margin-top: 20px;

            .text {
              display: flex;
              color: #464c58;
              padding: 10px 0;

              i {
                color: #F20303;
                font-size: 15px;
                margin-right: 6px;
              }

              span {
                margin-left: 3px;
              }
            }
          }
        }
      }
    }

  }

  .hxys {
    width: 100%;
    background-color: #FFF;
    height: 450px;

    .hxys-container {
      width: 80%;
      margin: 0 auto;
      padding-top: 50px;

      .item {
        margin-bottom: 30px;

        p {
          color: #858b95;
        }
      }

      .hxys-head {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
      }

      .hxys-head {
        h2 {
          font-size: xx-large;
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
        }
      }

      .hxys-content {
        display: flex;
        justify-content: center; /* 垂直方向居中（子元素整体在父容器中间） */
        align-items: center; /* 水平方向居中（每个子元素单独居中） */
        gap: 80px;

        .con {
          flex: 1;
          height: 255px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 20px;

          p {
            margin: 0 20px;
            font-size: 15px;
            text-align: center;
          }

          h2 {
            font-weight: bold;
          }

          img {
            width: 80px;
          }
        }
      }
    }

  }

  .khal {
    width: 100%;
    background-color: #F9F2F2;
    .khal-container {
      width: 80%;
      margin: 0 auto;
      padding: 50px 0;
      .item {
        margin-bottom: 30px;
        p {
          color: #858b95;
        }
      }

      .khal-head {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
      }

      .khal-head {
        h2 {
          font-size: xx-large;
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
        }
      }

      .khal-content {
        display: flex;
        justify-content: center; /* 垂直方向居中（子元素整体在父容器中间） */
        align-items: center; /* 水平方向居中（每个子元素单独居中） */
        flex-wrap: wrap;
        padding: 2px 16px;
        gap: 20px;
        /*精选案例盒子*/
        .jxal-box{
          width: 22%;

          min-height: 230px;
          height: auto;
          margin-bottom: 35px;
          justify-items: center;
          align-items: center;
          flex-direction: column;
          background-color: #fff;
          border-radius: 8px;
          position: relative;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
          .small-rect{
            width: 70%;
            background-image: linear-gradient(to right, #F20303, #F20303,#DBB6B6);
            position: absolute;
            transform: translate(0%, -50%);
            text-align: center;
            line-height: 42px;
            font-size: 22px;
            color: #fff;

          }
          .pic-box {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;
            justify-items: center;
            align-items: center;
            margin-left: 10px;
            .pic{
              padding: 2px 10px;
              width: 100%;
              height: auto;
            }
            /*.img-box {
              width: 23%;
              padding: 10px 10px;
              gap: 15px;
              .pic{
                align-items: center;
                width: 50px;
              }
            }*/
          }
        }
        .con {
          width: 95%;
          height: 632px;
          max-height: 632px;
          background-image: url("../../assets/images/home/khal.png");

          /* 3. 背景图适配规则（关键） */
          background-repeat: no-repeat; /* 禁止重复 */
          background-position: center; /* 居中显示 */
          background-size: contain; /* 完整显示图片，贴合div比例，无拉伸（推荐） */
        }
      }
    }

  }

  .lxwm {
    width: 100%;
    height: 260px;
    background-color: #FFF;
    .lxwm-container {
      width: 80%;
      margin: 0 auto;
      padding-top: 50px;

      .item {
        margin-bottom: 30px;

        p {
          color: #858b95;
        }
      }

      .lxwm-head {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
      }

      .lxwm-head {
        h2 {
          font-size: xx-large;
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
        }
      }

      .lxwm-content {
        display: flex;
        justify-content: center; /* 垂直方向居中（子元素整体在父容器中间） */
        align-items: center; /* 水平方向居中（每个子元素单独居中） */
        gap: 80px;

        .con {
          display: flex;
          justify-content: center;
          align-items: center;
          button{
            background-color: #FF6700;
            border-color: #FF6700;
            border-radius: 10px;
          }
        }
      }
    }

  }
}


</style>
